import { generateQuery, generateIdsQuery, generateFiltersQuery } from '../queries';
const buildQuery = entityConfigs => {
  const entityIds = [];
  const rawQueryStringified = '';
  const queryString = entityConfigs.map(entityConfig => {
    const {
      action,
      ids,
      entity,
      propsQuery,
      shapeKey,
      filtersObject
    } = entityConfig;
    if (!action) return '';
    const formatedEntity = `${entity[0].toUpperCase()}${entity.slice(1)}`;
    const filterQueryKey = action.indexOf('Published') !== -1 ? `Published${formatedEntity}` : formatedEntity;
    entityIds.push(...ids);
    const props = propsQuery.trim() || 'id';
    const singleItemQuery = filtersObject ? generateFiltersQuery(shapeKey, props, JSON.stringify(filtersObject), filterQueryKey) : generateIdsQuery(shapeKey, props, action, ids);
    return singleItemQuery;
  }).join(' ');
  return {
    query: queryString ? generateQuery(queryString) : '',
    ids: entityIds,
    rawQueryStringified
  };
};
export default buildQuery;
//# sourceMappingURL=build-query.js.map